/**
 * Feature flag for the GamingCare Tur message machinery.
 *
 * `GamingCareTur` (server) and `GamingCareTurClient` (client) are injected into
 * every page by the Tur AppShell. They drive the responsible-gaming login
 * messages, GRIMS reminders and real-time session messages, and make a number
 * of session-store, account and gaming-care API calls on every render.
 *
 * Set `NEXT_PUBLIC_ACCOUNT_TUR_GAMINGCARE_DISABLED=true` to short-circuit both
 * components. This is intended for test environments (e.g. E2E/MSW) that don't
 * want to mock the full gaming-care call graph. The flag defaults to enabled,
 * so production and normal local development behaviour is unchanged.
 *
 * A `NEXT_PUBLIC_` prefix is used so the value is inlined into the client bundle
 * and the check works in both the server and client components.
 *
 * @returns `true` if GamingCare Tur is disabled, `false` otherwise.
 */
export function isGamingCareTurDisabled(): boolean {
  return process.env.NEXT_PUBLIC_ACCOUNT_TUR_GAMINGCARE_DISABLED === 'true';
}
